import { Injectable, signal, effect, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private http = inject(HttpClient);

  saveUserNameColorOnServer(color: string) {
    return this.http.post(environment.platformUrl + 'api/NameColor/', { color });
  }
  // Appearance Settings
  fontColor = signal<string>(localStorage.getItem('settings_fontColor') || '#ffffff');
  fontStyle = signal<string>(localStorage.getItem('settings_fontStyle') || 'normal');
  userNameColor = signal<string>(localStorage.getItem('settings_userNameColor') || '#9f50ff');

  masterVolume = signal<number>(Number(localStorage.getItem('settings_masterVolume') || '80'));
  musicVolume = signal<number>(Number(localStorage.getItem('settings_musicVolume') || '50'));
  sfxVolume = signal<number>(Number(localStorage.getItem('settings_sfxVolume') || '100'));
  selectedInputDevice = signal<string>(localStorage.getItem('settings_selectedInputDevice') || 'default');
  selectedOutputDevice = signal<string>(localStorage.getItem('settings_selectedOutputDevice') || 'default');

  // UI State
  activeTab = signal<string>('account');

  // Data & Privacy Settings
  improveRivalForge = signal<boolean>(localStorage.getItem('settings_improveRivalForge') !== 'false');
  personalizeSponsoredContent = signal<boolean>(localStorage.getItem('settings_personalizeSponsoredContent') !== 'false');
  useThirdPartyData = signal<boolean>(localStorage.getItem('settings_useThirdPartyData') !== 'false');
  personalizeExperience = signal<boolean>(localStorage.getItem('settings_personalizeExperience') !== 'false');

  constructor() {
    // Keep localStorage in sync with the signals
    effect(() => {
      localStorage.setItem('settings_fontColor', this.fontColor());
    });
    effect(() => {
      localStorage.setItem('settings_fontStyle', this.fontStyle());
    });
    effect(() => {
      localStorage.setItem('settings_userNameColor', this.userNameColor());
    });
    effect(() => {
      localStorage.setItem('settings_masterVolume', this.masterVolume().toString());
    });
    effect(() => {
      localStorage.setItem('settings_musicVolume', this.musicVolume().toString());
    });
    effect(() => {
      localStorage.setItem('settings_sfxVolume', this.sfxVolume().toString());
    });
    effect(() => {
      localStorage.setItem('settings_improveRivalForge', this.improveRivalForge().toString());
    });
    effect(() => {
      localStorage.setItem('settings_personalizeSponsoredContent', this.personalizeSponsoredContent().toString());
    });
    effect(() => {
      localStorage.setItem('settings_useThirdPartyData', this.useThirdPartyData().toString());
    });
    effect(() => {
      localStorage.setItem('settings_personalizeExperience', this.personalizeExperience().toString());
    });
    effect(() => {
      localStorage.setItem('settings_selectedInputDevice', this.selectedInputDevice());
    });
    effect(() => {
      localStorage.setItem('settings_selectedOutputDevice', this.selectedOutputDevice());
    });


    // Apply appearance settings to document root
    effect(() => {
      const color = this.fontColor();
      const style = this.fontStyle();
      const userColor = this.userNameColor();
      
      const root = document.documentElement;
      root.style.setProperty('--chat-font-color', color);
      root.style.setProperty('--chat-font-style', style === 'italic' ? 'italic' : 'normal');
      root.style.setProperty('--chat-font-weight', style === 'bold' ? 'bold' : 'normal');
      root.style.setProperty('--chat-font-family', style === 'monospace' ? 'monospace' : 'inherit');
      root.style.setProperty('--current-username-color', userColor);
    });
  }
}
